const countingMenu = {
    "menu":[
        {
            "header":"Products",
            "key": "products",
            "icon":"inventory",
            "opened": false,
            "children":[
                {
                    "title": "Product Catalog",
                    "link": "/products",
                    "key": "products"
                },
                {
                    "title": "Categories",
                    "link": "/products/categories",
                    "key": "categories"
                },

                {
                    "title": "Storage Location",
                    "link":"/products/storages",
                    "key": "storages"
                }
            ]
        },
        {
            "header":"Counts",
            "key":"counts",
            "icon":"app_settings_alt",
            "opened": false,
            "children":[
                {
                    "title": "Counts",
                    "link": "/counts/basic",
                    "key": "basic"
                },
                {
                    "title": "Count History",
                    "link": "/counts",
                    "key": "counts"
                },
                {
                    "title": "Finalized Counts",
                    "link": "/counts/finalized",
                    "key": "finalized"
                }
            ]
        },
        {
            "header":"Warehouse",
            "key":"warehouse",
            "icon":"warehouse",
            "opened": false,
            "children":[
                {
                    "title": "Picking",
                    "key": "picking",
                    "link":"/pickings"
                },
                {
                    "title": "Receiving",
                    "key": "receiving",
                    "link":"/receivings"
                },
                {
                    "title": "Pick Lists",
                    "key": "picklist",
                    "link":"/picklists"
                }
            ]
        },
        {
            "header":"Tasks",
            "key":"tasks",
            "icon":"tasks",
            "link": "/tasks",
            "opened": false,
            "class": "menu_tasks",
        },
        {
            "header":"Reports",
            "key":"reports",
            "icon":"reports",
            "link": "/reports",
            "opened": false,
            "class": "menu_reports",
        },
        {
            "header":"Administration",
            "key":"administration",
            "icon":"settings_suggest",
            "opened": false,
            "children":[
                {
                    "title": "Users",
                    "key": "users",
                    "link":"/administration/users"
                },
                {
                    "title": "Locations",
                    "key": "locations",
                    "link":"/administration/locations"
                },
                {
                    "title": "Settings",
                    "link":"/administration/settings",
                    "key": "settings"
                },
                {
                    "title": "Integrations",
                    "link":"/integrations",
                    "key": "integrations"
                },
                {
                    "title": "Label Designer",
                    "link":"/label-designer",
                    "key": "labelDesigner"
                }
                // {
                //     "title": "UpgradePlan",
                //     "link":"/profile",
                //     "key": "upgrade_plan"
                // }
            ]
        }
    ]
}

export default countingMenu;
